<template>
    <div class="ui two column grid container">
        <div class="sixteen wide mobile five wide tablet four wide computer column">
            <div class="ui vertical fluid menu">
                <router-link to="/me/overview" class="item" :class="{ active: page === 'overview' }">Overview
                </router-link>
                <router-link to="/me/orders" class="item" :class="{ active: page === 'orders' }">Orders</router-link>
                <router-link to="/me/billing" class="item" :class="{ active: page === 'billing' }">Billing</router-link>
                <router-link to="/me/change_password" class="item" :class="{ active: page === 'change_password' }">
                    Change Password
                </router-link>
            </div>
        </div>
        <div class="sixteen wide mobile eleven wide tablet twelve wide computer column">
            <me-overview v-if="page === 'overview' && user !== null"></me-overview>
        </div>
    </div>
</template>
<script>
import MeOverview from './MeOverview';

export default {
  components: { MeOverview },
  name: 'UserAccount',

  data() {
    return {
      page: 'overview',
    };
  },

  watch: {
    $route() {
      this.page = this.$route.params.page;
    },
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/user/UserAccount.vue